// 工程师变更
<template>
	<div id="containt">
		<el-tabs v-model="activeName" class="tab-box">
			<el-tab-pane label="常规" name="first">
				<editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
					@reload="$reloadHandle"></editView>
			</el-tab-pane>
			<el-tab-pane label="列表" name="second">
				<div class="grid-height" style="height: calc(100vh - -35px);">
					<vxe-grid show-overflow height="100%" :stripe="true" border="default" :row-config="{ isHover: true }"
						ref="table-m1" v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
						@custom="$vxeTableUtil.customHandle">

						<template #form>
							<div class="clearfix screen-btns">
								<div class="fl">
									<vxe-button status="primary" class="button-sty" icon="el-icon-plus" v-if="snEngineerChangeAdd||mySnEngineerChangeAdd"
										@click="openEditDialog">新增</vxe-button>
								</div>
								<div class="fr">
									<!--									<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"-->
									<!--										status="primary" plain>重置</vxe-button>-->
									<vxe-button status="warning" icon="el-icon-search" class="button-sty"
										@click="searchEvent">搜索</vxe-button>
								</div>
							</div>
							<vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData"
								@submit="searchEvent" @reset="searchEvent">
								<vxe-form-item title="所属网点:" field="code">
									<template v-slot>
										<el-input v-model="searchData.siteName" size="small" clearable />
									</template>
								</vxe-form-item>
								<vxe-form-item title="姓名:" field="code">
									<template v-slot>
										<el-input v-model="searchData.engineerName" size="small" clearable />
									</template>
								</vxe-form-item>
								<vxe-form-item title="手机:" field="code">
									<template v-slot>
										<el-input v-model="searchData.engineerMobile" size="small" clearable />
									</template>
								</vxe-form-item>
								<vxe-form-item title="类型:" field="engineerType" >
									<template v-slot>
                    <el-select v-model="searchData.engineerType" clearable>
                    	<el-option :value="1" label="自有"></el-option>
                    	<el-option :value="2" label="可控"></el-option>
                    	<el-option :value="3" label="合约"></el-option>

                    </el-select>
									</template>
								</vxe-form-item>

							</vxe-form>
						</template>
						<template #pager>
							<pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
						</template>
					</vxe-grid>
				</div>
			</el-tab-pane>
		</el-tabs>
    <el-dialog
      :visible.sync="showPicDialog"
      title="流程图">
      <img v-if="showPicDialog" :src="actPicUrl" width="100%">
    </el-dialog>
	</div>
</template>

<script>
import editView from './edit.vue';
import { tableOption } from '@/const/crud/admin/tenant';
import { initVxeTable } from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import {mapGetters} from "vuex";
import request from "@/router/axios";
import {siteMixins} from "@/mixins/tabChang";
export default {
  mixins: [siteMixins],
	components: { editView, pager },
	data() {
		return {
      actPicUrl:"",
      showPicDialog:false,
      snEngineerChangeEdit : false,
      snEngineerChangeAdd : false,
      mySnEngineerChangeEdit : false,
      mySnEngineerChangeAdd : false,
			total: 0,
			editViewDataUpdateFlag: false,
			activeName: 'second',
			dataId: 0,
			showEdit: false,
			vxeOption: {},
			// 查询参数
			formData: {
				searchCount: false,  // 是否分页
				current: 1,  // 当前页面
				size: 0,  // 页面数据量
				siteName: '',
				engineerType: '',
				engineerName: ''
			},
			searchData: {
				siteName: '',
				engineerType: '',
				engineerName: '',
				engineerMobile: null,
			},
			pageSizes: [10, 20, 100],

		};
	},
	watch: {
		activeName(newVal) {
			if (newVal === 'second' && this.editViewDataUpdateFlag) {
				this.getTableData()
			}
		},
		total(newVal) {
			this.$refs.pager.tableDataTotal = newVal
		},
	},
	mounted() {

	},
  computed: {
    ...mapGetters(["permissions"])
  },
  created(){
    this.snEngineerChangeEdit = this.permissions['snEngineerChangeEdit']
    this.snEngineerChangeAdd = this.permissions['snEngineerChangeAdd']
    this.mySnEngineerChangeEdit = this.permissions['mySnEngineerChangeEdit']
    this.mySnEngineerChangeAdd = this.permissions['mySnEngineerChangeAdd']
  },
	methods: {

    // 菜单选中
    handleCommand(command, row) {
      if(command == 5){
        request({
          url: '/act/wf/startWf',
          method: 'post',
          data:{id:row.id,tableKey:"SnEngineerChange",orgId:row.orgId,orderNo:row.changeNo},
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          console.log("response",response)
          if(response.data.type == "success"){
            this.$message({ message:response.data.content,type: 'success'});
            this.flushed();
            this.reload();
          }else{
            this.$message({ message:response.data.content,type: 'warning'});
          }
        })
      }else if (command == 1){
        this.updateChangeStat(2,row.id.toString())
      }else if (command == 2){
        this.passTheAudit(row.id.toString())
      }else if (command == 3){
        this.updateChangeStat(6,row.id.toString())
      }else if (command == 4){
        this.updateChangeStat(99,row.id.toString())
      }else if (command == 6){
        this.actPicUrl = `/act/wf/wfview/` + row.processId
        this.showPicDialog = true
      }
    },

    updateChangeStat(changeStat,id){ //更新变更状态
      console.log("this.dataId",this.dataId)
      console.log("changeStat",changeStat)
      this.$http({
        url: api.snEngineerChange.updateChangeStatUrl,
        method: 'post',
        data: {
          changeId: id,
          changeStat : changeStat
        }
      }).then(res => {
        if (res.data.data){
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        }
        this.flushed();
        this.reload()
      })
    },
    passTheAudit(id){ // 审核通过
      this.$http({
        url: api.snEngineerChange.passTheAuditUrl,
        method: 'post',
        data: {
          id: id
        }
      }).then(res => {
        if (res.data.data){
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        }
        this.flushed();
        this.reload()
      })
    },

		flushed() {
			this.$refs['table-m1'].commitProxy('reload');
		},

		// 分页功能
		changeTablePage(page, flag) {
			console.log('分页数据', page, this.formData)
			this.formData.size = page.pageSize
			this.formData.current = page.currentPage
			this.formData.searchCount = flag
			this.initTableList();
		},

		setFormData() {
			this.formData.siteName = this.searchData.siteName
			this.formData.engineerName = this.searchData.engineerName
			this.formData.engineerType = this.searchData.engineerType
			this.formData.engineerMobile = this.searchData.engineerMobile
		},

		// 搜索
		searchEvent() {
			this.setFormData()

			this.$refs.pager.clearStoreTableDataTotal()
			this.formData.current = 1
			this.formData.searchCount = false
			this.$refs.pager.reset()  // 重置分页器
			this.flushed()
		},
		// 重置
		resetEvent() {
			this.searchData = {
				siteName: '',
				engineerType: '',
				engineerName: '',
				engineerMobile: null
			}

			this.formData.searchCount = false
			this.formData.current = 1
			this.setFormData()

			this.$refs.pager.reset()  // 重置分页器
			this.flushed()
		},
		// 新增
		openEditDialog(id) {
			this.dataId = !id || typeof id == 'object' ? 0 : id;
			this.activeName = 'first';
			this.$openEditView('showEdit');
		},



		initTableList() {
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'basic_fault_code_list-m1',
				path: api.snEngineerChange.getPageDataUrl,
				param: this.formData,
				method: 'post',
				height: '800px',
				columns: [
					{ type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left' },
					{ title: '变更单号', field: 'changeNo', width: 130, },
					{
						field: 'changeType', title: '变更类型', width: 140, slots: {
							default: ({ row }) => {
								if (row.changeType == 1) {
									return [
										<div class="txt-status">
											<span>新增</span>
										</div>
									];
								} else if (row.changeType == 2) {
                  return [
                    <div class="txt-status">
                      <span>资料变更</span>
                    </div>
                  ];
                }
							}
						}
					},
					{
						field: 'changeStat', title: ' 变更状态', width: 120, slots: {
							default: ({ row }) => {
								if (row.changeStat == 1) {
									return [
										<div class="txt-status">
											<span>制单</span>
										</div>
									];
								} else if (row.changeStat == 2) {
									return [
										<div class="txt-status">
											<span>审核中</span>
										</div>
									];
								} else if (row.changeStat == 5) {
									return [
										<div class="txt-status ">
											<span>已审核</span>
										</div>
									];
								} else if (row.changeStat == 6) {
                  return [
                    <div class="txt-status disable">
                      <span>驳回</span>
                    </div>
                  ];
                } else if (row.changeStat == 99) {
									return [
										<div class="txt-status disable">
											<span>取消</span>
										</div>
									];
								}
							}
						}
					},
					{ title: '所属网点', field: 'siteName', width: 180, },
					// { title: '服务中心(所属机构)', field: 'orgName', width: 180, },
          { title: '工号', field: 'engineerCode', width: 150,slots: {
              // 使用 JSX 渲染
              default: ({row}) => {
                return [
                  <span style="color: blue">{row.engineerCode}</span>
                ]
              }
            }
          },
					{ title: '姓名', field: 'engineerName', width: 80, },
					{ title: '手机', field: 'engineerMobile', width:120, },
					{
						field: '', title: '类别', width: 120, slots: {
							default: ({row}) => {
                if (row.engineerType == 1) {
                  return [
                    <div >
                      <span>自有</span>
                    </div>
                  ];
                } else if (row.engineerType == 2) {
                  return [
                    <div>
                      <span>可控</span>
                    </div>
                  ];
                } else if (row.engineerType == 3) {
                  return [
                    <div>
                      <span>合约</span>
                    </div>
                  ];
                }
              }
						}
					},
          {
            field: 'postStat', title: '在职状态', width: 130, slots: {
              default: ({ row }) => {
                if (row.postStat == 1) {
                  return [
                    <div class="txt-status">
                      <span>在职</span>
                    </div>
                  ];
                } else if (row.postStat == 3) {
                  return [
                    <div class="txt-status">
                      <span>休假中</span>
                    </div>
                  ];
                } else if (row.postStat == 9) {
                  return [
                    <div class="txt-status disable">
                      <span>离职</span>
                    </div>
                  ];
                }
              }
            }
          },
					{
						field: 'stat', title: '启用', width: 130, slots: {
							default: ({ row }) => {
								if (row.stat == 1) {
									return [
										<div class="txt-status">
											<span>正常</span>
										</div>
									];
								} else if (row.stat == 2) {
									return [
										<div class="txt-status disable">
											<span>禁用App</span>
										</div>
									];
								} else if (row.stat == 9) {
									return [
										<div class="txt-status disable">
											<span>禁用</span>
										</div>
									];
								}
							}
						}
					},
					{ title: '创建人', field: 'createBy', width: 100, },
					{ field: 'createTime', title: '创建时间', width: 230 },
					{
						width: 47, fixed: 'right', title: '', sortable: false, slots: {
							default: ({ row }) => {
                if (this.snEngineerChangeEdit||this.mySnEngineerChangeEdit){
                  return [
                    <div>
                      <a href="javascript:void(0);" class="a-link"
                         onclick={() => {
                           this.openEditDialog(row.id);
                         }}
                      >
                        <el-tooltip enterable={false} effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
                          <i class="el-icon-edit" />
                        </el-tooltip>
                      </a>
                    </div>
                  ];
                }
							}
						}
					},
          {
            width: 47, fixed: 'right', title: '', sortable: false, slots: {
              default: ({ row }) => {
                if(row.changeStat === 1 && !row.processId){
                  return [
                    <div>
                      <el-dropdown onCommand={($event) => {
                        this.handleCommand($event, row);
                      }} >
                    <span class="el-dropdown-link">
                      <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                    </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="1">提交审核</el-dropdown-item>
                          <el-dropdown-item command="4">取消</el-dropdown-item>
                          <el-dropdown-item command="5">启动流程</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  ]
                }else if (row.changeStat === 2 && !row.processId){
                  return [
                    <div>
                      <el-dropdown onCommand={($event) => {
                        this.handleCommand($event, row);
                      }} >
                    <span class="el-dropdown-link">
                      <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                    </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="2">审核通过</el-dropdown-item>
                          <el-dropdown-item command="3">驳回</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  ]
                }else if (row.changeStat === 6 && !row.processId){
                  return [
                    <div>
                      <el-dropdown onCommand={($event) => {
                        this.handleCommand($event, row);
                      }} >
                    <span class="el-dropdown-link">
                      <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                    </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="4">取消</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  ]
                }else if (row.processId){
                  return [
                    <div>
                      <el-dropdown onCommand={($event) => {
                        this.handleCommand($event, row);
                      }} >
                    <span class="el-dropdown-link">
                      <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                    </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="6">查看流程</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  ]
                } else{
                  return [
                    <div>
                      <el-dropdown onCommand={($event) => {
                        this.handleCommand($event, row);
                      }} >
                    <span class="el-dropdown-link">
                      <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                    </span>
                        <el-dropdown-menu slot="dropdown">
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  ]
                }
              }
            }
          }
				]
			};
			this.vxeOption = initVxeTable(tableOption);
			this.flushed()
		},
	}
};
</script>
<style lang="scss" >
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
	.el-radio__inner {
		border: 0px;
		background: transparent;
	}

	.el-radio__input.is-checked .el-radio__inner {
		background: none;
	}

	.el-radio {
		height: 100%;
		width: 150px;
		position: absolute;
		z-index: 10;
	}
}</style>
